/**
 * =============================================================================
 * product-form-manager.js
 * =============================================================================
 * Generate ProductForm objects for all product forms on page.
 * =============================================================================
 */

 import ProductForm from "./product-form";

 var ProductFormManager = {
   forms: {},
 
   init: function() {
     // Get all of the product containers. This will usually just be 1 (i.e the
     // product page), but could be multiple (i.e. multiple sections on a JSON
     // template using the 'featured-product' section)
     let productContainers = document.querySelectorAll(".product-container");
     productContainers.forEach(productContainer => {
       let productForm = new ProductForm(productContainer); 
       this.forms[productContainer.id] = productForm;
     });
 
     // console.log(`[P-F-M] Found ${Object.keys(this.forms).length} product form(s)`, this.forms);
   } 
 }
 
 export default ProductFormManager;